import { useContext, useEffect, useState } from 'react';
import { toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-number-input/style.css';
import TopLoadingBar from '../topLoadingBar/topLoadingBar';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import { CLIENT_TYPE, ERROR_CODE } from '../../constant';
import LogOut from '../../utils/logout';
import { useNavigate, useParams } from 'react-router';
import BillManagementContext from '../../context/BillManagementContext/BillManagementContext';
import {
  Add_Payment_Bill,
  Add_Vender_Bill,
  Edit_Bill_Management,
  Edit_Vender_Bill_Management,
  payment_Bill_Delete,
  payment_Bill_List,
  Vender_Bill_Delete,
  Vender_Bill_Detail,
  Vender_Bill_List
} from '../../api/BillManagementApi/BillManagementApi';
import PaymentBillManagementAddModel from './PaymentBillManagementAddModel';
import PaymentAddModel from './PaymentAddModel';
import PaymentBillManagementItem from './PaymentBillManagementItem';
import PaymentList from './PaymentList';
import { FILE_API } from '../../api/Bank Master api/BankMasterAPi';

const PaymentBillManagement = () => {
  const {
    setModal,
    sortOrder,
    setSortOrder,
    sortBy,
    setSortBy,
    filter,
    setFilter,
    modal,
    progress,
    setProgress,
    setToggle,
    filterOrderId,
    editIndex,
    seteditIndex,
    togglesubmit,
    vendorId,
    setVendorId,
    setBillForm,
    setBillListValue,
    venderBillFormData,
    setVenderBillFormData,
    setPaymentListModal,
    setPaymentListValue,
    setPaymetnModal,
    setPaymentBillFormData,
    paymentBillFormData,
    setAllPrice,
    isMinusAmount,
    setIsMinusAmount
  } = useContext(BillManagementContext);
  const { vendorId: vender } = useParams();
  const { loaderShow, setLoaderShow, responseLoader, setResponseLoader } = useContext(OrganizationContext);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [record, setRecord] = useState(0);
  const history = useNavigate();
  const [error, setError] = useState(false);
  const [temvendorBillId, setTemvendorBillId] = useState('');
  const today = new Date().toISOString().split('T')[0];
  /**
   * Accommodation_List List api call function and useEffect use to call function
   */

  const getData = async () => {
    setResponseLoader(!responseLoader);
    try {
      let paramsObj = {
        pageNumber: page,
        recordsPerPage: pageSize,
        sortOrder,
        sortBy,
        vendorId: vender
      };
      const activeFilters = Object.fromEntries(Object.entries(filter).filter(([_, v]) => v));
      paramsObj['search'] = activeFilters;
      const { data } = await Vender_Bill_List(paramsObj);
      if (data.status === 200) {
        setBillListValue(data.payload.data);
        setRecord(data.pager.totalRecords);
        setResponseLoader(false);
      } else {
        setBillListValue([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      setResponseLoader(false);
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  useEffect(() => {
    getData();
    setProgress(100);
  }, [page, pageSize, sortOrder, sortBy, filter, filterOrderId]);

  /**
   * Add donation master model open function call
   */

  const AddModel = () => {
    EmptyFeild();
    setModal(true);
    setToggle(true);
  };
  const AddPaymentModel = ({ vendorBillId, dueAmount, totalAmount, paidAmount }) => {
    setPaymentBillFormData((prev) => {
      return {
        ...prev,
        vendorId: vender,
        vendorBillId
      };
    });
    setAllPrice({
      dueAmount: dueAmount,
      totalAmount: totalAmount,
      paidAmount: paidAmount,
      paybleAmount: 0
    });
    EmptyBillFeild();
    setPaymetnModal(true);
  };
  const getPaymentListData = async (vendorBillId) => {
    setResponseLoader(!responseLoader);
    setTemvendorBillId(vendorBillId);
    try {
      const { data } = await payment_Bill_List(vender, vendorBillId);
      if (data.status === 200) {
        setPaymentListValue(data.payload.data);
        setPaymentListModal(true);
        setResponseLoader(false);
      } else {
        setPaymentListValue([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      setResponseLoader(false);
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };
  const showPaymentList = (vendorBillId) => {
    getPaymentListData(vendorBillId);
  };
  const PaymentListClose = () => {
    setPaymentListModal(false);
  };

  /**
   * sorting funcion call
   */

  const sorting = (col) => {
    if (sortOrder === '') {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder('ASC');
    }
    if (sortOrder === 'ASC') {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder('DSC');
    }
    if (sortOrder === 'DSC') {
      setSortBy();
      setSortOrder('');
    }
  };

  /**
   * Search function call
   */
  const handleFilter = (e) => {
    if (e.target.value === '') {
      setFilter(e.target.value);
    } else {
      setFilter(e.target.value);
    }
  };

  const deleteHandle = async (vendorBillId) => {
    const isConfirm = window.confirm('Are you sure?');
    if (isConfirm) {
      setLoaderShow(!loaderShow);
      try {
        const fromData = { vendorBillId, vendorId: vender };
        const { data } = await Vender_Bill_Delete(fromData);
        if (data.status === 200) {
          setLoaderShow(false);
          getData();
        } else {
          setBillListValue([]);
        }
      } catch (error) {
        if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
          LogOut(history);
        }
        toast.error(error?.response?.data?.message, {
          autoClose: 1000,
          transition: Zoom
        });
        setLoaderShow(false);
      }
    }
  };
  const deletePaymentHandle = async (id) => {
    const isConfirm = window.confirm('Are you sure?');
    if (isConfirm) {
      setLoaderShow(!loaderShow);
      try {
        const { data } = await payment_Bill_Delete(id);
        if (data.status === 200) {
          setLoaderShow(false);
          getData();
          getPaymentListData(temvendorBillId);
        } else {
          setBillListValue([]);
        }
      } catch (error) {
        if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
          LogOut(history);
        }
        toast.error(error?.response?.data?.message, {
          autoClose: 1000,
          transition: Zoom
        });
        setLoaderShow(false);
      }
    }
  };

  const readUrl = async (event) => {
    let formData = new FormData();
    formData.append('type', CLIENT_TYPE.BILL);
    formData.append('file', event);
    try {
      const { data } = await FILE_API(formData);
      if (data.status === 200) {
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom
        });
        return data.payload.imageUrl;
        // setUrl(data.payload.imageUrl);
        // setBase(data.payload.baseUrl);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!venderBillFormData?.billDate || !venderBillFormData?.totalAmount) {
      setError(true);
    } else {
      setLoaderShow(true);
      if (editIndex !== -1 && venderBillFormData?.vendorBillId) {
        try {
          let filePath = '';
          if (venderBillFormData?.billImage) {
            if (typeof venderBillFormData.billImage === 'string') {
              filePath = venderBillFormData.billImage;
            } else {
              filePath = await readUrl(venderBillFormData.billImage);
            }
          }
          const formData = {
            ...venderBillFormData,
            billImage: filePath,
            vendorId: vender,
            totalAmount: +venderBillFormData?.totalAmount
          };
          const { data } = await Edit_Vender_Bill_Management(formData, venderBillFormData?.vendorBillId);
          if (data.status === 200) {
            toast.success(data.message, {
              autoClose: 1000
            });
            setModal(false);
            getData();
            EmptyFeild();
          }
        } catch (error) {
          if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
            LogOut(history);
          }
          toast.error(error?.response?.data?.message, {
            autoClose: 1000,
            transition: Zoom
          });
          setLoaderShow(false);
        }
      } else {
        try {
          let filePath = '';
          if (venderBillFormData?.billImage) {
            filePath = await readUrl(venderBillFormData?.billImage);
          }

          const formData = {
            ...venderBillFormData,
            billImage: filePath,
            vendorId: vender
          };
          setLoaderShow(!loaderShow);
          const { data } = await Add_Vender_Bill(formData);
          if (data.status === 200) {
            toast.success(data.message, {
              autoClose: 1000,
              transition: Zoom
            });
            setModal(false);
            getData();
            EmptyFeild();
          }
        } catch (error) {
          if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
            LogOut(history);
          }
          toast.error(error?.response?.data?.message, {
            autoClose: 1000,
            transition: Zoom
          });
        } finally {
          setLoaderShow(false);
        }
      }
    }
  };

  const EmptyFeild = () => {
    setError(false);
    setVenderBillFormData({
      vendorId: null,
      billDate: today,
      totalAmount: 0,
      paidAmount: 0,
      paymentMode: '',
      referenceNo: '',
      notes: '',
      billImage: '',
      vendorBillId: null
    });
    setLoaderShow(false);
    setVendorId('');
    seteditIndex('');
  };
  const EmptyBillFeild = () => {
    setBillForm({
      vendorId: '',
      billNo: '',
      billDate: today,
      totalAmount: '',
      paidAmount: '',
      paymentMode: '',
      billImage: '',
      notes: '',
      referenceNo: ''
    });
    setPaymentBillFormData((prev) => {
      return {
        ...prev,
        paymentDate: today,
        amount: null,
        paymentMode: null,
        referenceNo: null,
        notes: ''
      };
    });
    setLoaderShow(false);
  };

  const onBillSubmit = async (e) => {
    debugger;
    e.preventDefault();
    if (
      !paymentBillFormData?.paymentDate ||
      !paymentBillFormData?.amount ||
      !paymentBillFormData?.paymentMode ||
      isMinusAmount
    ) {
      setError(true);
    } else {
      try {
        setLoaderShow(!loaderShow);
        const { data } = await Add_Payment_Bill({ ...paymentBillFormData });
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            transition: Zoom
          });
          setPaymetnModal(false);
          getData();
          EmptyFeild();
        }
      } catch (error) {
        if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
          LogOut(history);
        }
        toast.error(error?.response?.data?.message, {
          autoClose: 1000,
          transition: Zoom
        });
        setLoaderShow(false);
      }
    }
  };

  const editHandle = async (vendorBillId) => {
    setLoaderShow(!loaderShow);
    try {
      const fromData = { vendorBillId, vendorId: vender };
      const { data } = await Vender_Bill_Detail(fromData);
      if (data.status === 200) {
        const payload = data.payload.data;
        setLoaderShow(false);
        setVenderBillFormData({
          vendorId: payload?.vendorId,
          billDate: payload?.billDate || null,
          totalAmount: payload?.totalAmount || null,
          paidAmount: payload?.paidAmount || null,
          paymentMode: payload?.paymentMode || '',
          referenceNo: payload?.referenceNo || '',
          notes: payload?.notes || '',
          vendorBillId: payload?.vendorBillId || vendorBillId || null
        });
        setModal(true);
        setToggle(true);
        seteditIndex(payload?.vendorBillId || vendorBillId);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
      setLoaderShow(false);
    }
  };
  const close = () => {
    setModal(!modal);
    EmptyFeild();
  };
  const billClose = () => {
    setPaymetnModal(false);
  };

  return (
    <>
      <div>
        <TopLoadingBar progress={progress} setProgress={setProgress} />
        <PaymentBillManagementAddModel onSubmit={onSubmit} close={close} error={error} />
        <PaymentAddModel onSubmit={onBillSubmit} close={billClose} error={error} />
        <PaymentList close={PaymentListClose} deleteHandle={deletePaymentHandle} />
        <PaymentBillManagementItem
          vender={vender}
          handleFilter={handleFilter}
          sorting={sorting}
          AddModel={AddModel}
          AddPaymentModel={AddPaymentModel}
          deleteHandle={deleteHandle}
          editHandle={editHandle}
          showPaymentList={showPaymentList}
          setPage={setPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          page={page}
          record={record}
          getData={getData}
        />
      </div>
    </>
  );
};
export default PaymentBillManagement;
